import ReactECharts from 'echarts-for-react';
import { PieChart } from 'lucide-react';
import { useRevenueExpenseByCategory } from '@/hooks/useFinancialData';
import { formatBRL } from '@/lib/format';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { EmptyState } from '@/components/ui/EmptyState';

const REVENUE_COLORS = ['#14a655', '#1ea56e', '#7ee0b4', '#a9deb0', '#d3eede'];
const EXPENSE_COLORS = ['#dc2626', '#ea580c', '#f59e0b', '#fbbf24', '#fde68a', '#fef3c7', '#fef9c3'];

function buildOption(data: Array<{ name: string; value: number }>, colors: string[]) {
  return {
    tooltip: {
      trigger: 'item',
      backgroundColor: 'rgba(15,61,46,0.95)',
      textStyle: { color: '#F8FAFC' },
      valueFormatter: (v: number) => formatBRL(v),
    },
    legend: {
      bottom: 0,
      icon: 'circle',
      itemWidth: 8,
      itemHeight: 8,
      textStyle: { color: '#64748b', fontSize: 11 },
      type: 'scroll',
    },
    color: colors,
    series: [
      {
        type: 'pie',
        radius: ['52%', '78%'],
        center: ['50%', '42%'],
        avoidLabelOverlap: true,
        itemStyle: { borderColor: '#fff', borderWidth: 2, borderRadius: 4 },
        label: { show: false },
        labelLine: { show: false },
        data,
      },
    ],
  };
}

export function RevenueByCategoryChart() {
  const { revenue, loading } = useRevenueExpenseByCategory();

  return (
    <div className="card p-5 h-full">
      <SectionHeader title="Receitas por categoria" subtitle="Mês corrente" />
      {loading ? (
        <div className="h-64 rounded-xl bg-surface-subtle animate-pulse" />
      ) : revenue.length === 0 ? (
        <EmptyState icon={PieChart} title="Sem receitas categorizadas" description="Classifique as transações para ver a distribuição." />
      ) : (
        <ReactECharts option={buildOption(revenue, REVENUE_COLORS)} style={{ height: 280 }} notMerge />
      )}
    </div>
  );
}

export function ExpenseByCategoryChart() {
  const { expense, loading } = useRevenueExpenseByCategory();

  return (
    <div className="card p-5 h-full">
      <SectionHeader title="Despesas por categoria" subtitle="Mês corrente" />
      {loading ? (
        <div className="h-64 rounded-xl bg-surface-subtle animate-pulse" />
      ) : expense.length === 0 ? (
        <EmptyState icon={PieChart} title="Sem despesas categorizadas" description="Classifique as transações para ver a distribuição." />
      ) : (
        <ReactECharts option={buildOption(expense, EXPENSE_COLORS)} style={{ height: 280 }} notMerge />
      )}
    </div>
  );
}
